import { render } from "./Positions.vue?vue&type=template&id=6e75aaa7&scoped=true"
import script from "./Positions.vue?vue&type=script&lang=js"
export * from "./Positions.vue?vue&type=script&lang=js"

import "./Positions.vue?vue&type=style&index=0&id=6e75aaa7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e75aaa7"]])

export default __exports__